export default function useInputCurrencyFormat(currency = "BRL") {
  return (numStr: string) => {
    if (numStr === "") return ""

    return new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency,
    }).format(Number(numStr.replace(/\D+/g, "")) / 100)
  }
}
